import React from 'react';
import PropTypes from 'prop-types';
import AccountPlayerFreePlaysHeader from './AccountPlayerFreePlaysHeader';
import AccountPlayerFreePlaysRow from './AccountPlayerFreePlaysRow';
import TableFooter from '../helpers/TableFooter';
import { isEmpty } from 'lodash';
import { tableNoResultsDefault, tableSpinnerDefault } from '../helpers/TableHelpers';

const COLUMNS_COUNT = 4;

const AccountPlayerFreePlays = ({ id, meta, freePlays, onPageChange, onSortChange }) => {
  const rows = freePlays.map(row => (<AccountPlayerFreePlaysRow key={`${row.id}`} data={row} />));
  return (
    <div className='u-margin-bottom--gutter' id='free-plays'>
      <strong>Free Play Activity</strong>
      <div className='u-margin-top--small cs-bg--light table-scroll'>
        <table className='o-table o-table--bordered'>
          <AccountPlayerFreePlaysHeader id={id} meta={meta} onSortChange={onSortChange} />
          <tbody>
            { (isEmpty(freePlays) && meta.totalPages === 0) ? tableNoResultsDefault(COLUMNS_COUNT) :
              isEmpty(freePlays) ? tableSpinnerDefault(COLUMNS_COUNT) : rows }
          </tbody>
        </table>
      </div>
      { meta.totalCount > 0 && <TableFooter meta={meta} onPageChange={onPageChange} /> }
    </div>
  );
}

AccountPlayerFreePlays.propTypes = {
  id: PropTypes.number.isRequired,
  meta: PropTypes.object.isRequired,
  freePlays: PropTypes.arrayOf(PropTypes.object).isRequired,
  onPageChange: PropTypes.func.isRequired,
  onSortChange: PropTypes.func.isRequired,
}

export default AccountPlayerFreePlays;
